import { PropsWithChildren, useMemo } from 'react';

import { CircularProgressCentered } from '~/components/CircularProgressCentered/CircularProgressCentered';

import { ConfigContextProvider, ConfigContextState } from './ConfigProvider.context';
import { useRemoteConfig } from './ConfigProvider.hook';

export const ConfigProvider = ({ children }: PropsWithChildren) => {
  const { loading, config } = useRemoteConfig();

  const value: ConfigContextState = useMemo(
    () => ({
      ...config,
      getMapsUrl: (address: string) => {
        const queryParams = new URLSearchParams();
        queryParams.set('query', address);
        return `https://www.google.com/maps/search/?api=1&parameters&${queryParams.toString()}`;
      },
    }),
    [config],
  );

  if (loading) {
    return <CircularProgressCentered color="inherit" />;
  }

  return <ConfigContextProvider value={value}>{children}</ConfigContextProvider>;
};
